export interface ChangelogEntry {
  version: string
  date: string
  highlights: {
    icon: 'sparkles' | 'zap' | 'palette' | 'music' | 'monitor' | 'lightbulb' | 'settings' | 'rocket' | 'search' | 'library' | 'volume' | 'image' | 'download'
    title: string
    description: string
  }[]
}

export const changelog: ChangelogEntry[] = [
  {
    version: '0.13.0',
    date: '2025-12-22',
    highlights: [
      {
        icon: 'lightbulb',
        title: 'WLED & LED Strip Control',
        description: 'Full support for WLED devices and LED strips with gradient effects, color control, and scene integration.'
      },
      {
        icon: 'palette',
        title: 'Color Temperature Slider',
        description: 'New CCT slider for controlling warm/cool white temperature on compatible smart lights.'
      },
      {
        icon: 'download',
        title: 'Auto Updates',
        description: 'The desktop app now checks for updates automatically and notifies you when a new version is available.'
      },
      {
        icon: 'monitor',
        title: 'Mobile Improvements',
        description: 'Better mobile editor experience, optimized image caching, and improved iOS performance.'
      },
    ]
  },
  {
    version: '0.12.0',
    date: '2025-12-03',
    highlights: [
      {
        icon: 'image',
        title: 'Album Cover Art',
        description: 'Music nodes now display beautiful album artwork from your audio files.'
      },
      {
        icon: 'volume',
        title: 'Master Volume',
        description: 'New master fader to control the overall volume for each display.'
      },
      {
        icon: 'zap',
        title: 'Smooth Scene Transitions',
        description: 'Music keeps playing seamlessly when switching between scenes with the same audio.'
      },
      {
        icon: 'sparkles',
        title: 'Faster Uploads',
        description: 'Audio files appear right away in your graph while they finish uploading.'
      },
    ]
  },
  {
    version: '0.11.0',
    date: '2025-12-03',
    highlights: [
      {
        icon: 'music',
        title: 'Playlist Nodes',
        description: 'Create playlist containers to organize music tracks with shuffle, repeat modes, and volume control.'
      },
      {
        icon: 'zap',
        title: 'Scene-Playlist Linking',
        description: 'Link playlists to scenes for automatic playback when scenes are activated.'
      },
      {
        icon: 'sparkles',
        title: 'Collapsible Containers',
        description: 'Collapse containers and playlists to declutter your scene graph.'
      },
      {
        icon: 'palette',
        title: 'New Themes',
        description: 'Four new themes: Midnight (deep blue), Flashbang (ultra bright), Hell (fiery red), and Forest (natural green).'
      },
    ]
  },
  {
    version: '0.8.0',
    date: '2025-11-30',
    highlights: [
      {
        icon: 'library',
        title: 'Audio Library',
        description: 'Organize your audio files in folders. Drag files to the scene graph to create music nodes.'
      },
      {
        icon: 'search',
        title: 'Graph Search',
        description: 'Press Ctrl+F to search scenes, Spotify playlists, and audio files. Filter by type with quick toggles.'
      },
      {
        icon: 'volume',
        title: 'Spotify Volume Control',
        description: 'Adjust Spotify playback volume directly from the Audio panel with a new volume slider.'
      },
      {
        icon: 'sparkles',
        title: 'Social Login',
        description: 'Sign in with Discord or Spotify for a faster authentication experience.'
      },
      {
        icon: 'palette',
        title: 'Refined Bubble UI',
        description: 'New golden-framed bubble components with smooth animations and better visual hierarchy.'
      },
    ]
  },
  {
    version: '0.2.0',
    date: '2025-11-28',
    highlights: [
      {
        icon: 'sparkles',
        title: 'New Floating UI',
        description: 'Redesigned interface with floating controls for displays, audio, and lights.'
      },
      {
        icon: 'music',
        title: 'Enhanced Audio Controls',
        description: 'Per-track volume control with real-time sync across all displays.'
      },
      {
        icon: 'palette',
        title: 'Improved Scene Graph',
        description: 'Drag and drop nodes with better visual feedback and Spotify artwork.'
      },
      {
        icon: 'monitor',
        title: 'Multi-Display Support',
        description: 'Easily manage and preview multiple displays from the floating bar.'
      },
      {
        icon: 'rocket',
        title: 'Stupid Bugfix',
        description: 'Im a stupid idiot and broke the main Featue.'
      },
    ]
  }
]

export const CURRENT_VERSION = changelog[0].version
